import EditIcon from '@mui/icons-material/Edit'
import { IconButton } from '@mui/material'
import { useHandleUrl } from 'hooks/useHandleUrl'
import { useLocation, useNavigate } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

const EditBimLinkButton = ({ bimlink }) => {
  const { changeLocation } = useHandleUrl()
  const location = useLocation()
  const navigate = useNavigate()

  const handleOnClick = e => {
    e.stopPropagation()
    navigate(changeLocation(`${location.pathname}/edit-bimlink/${bimlink._id}`))
  }

  return (
    <>
      <Tooltip
        anchorSelect=".edit-btn"
        style={{ zIndex: 99999999, fontSize: '10px' }}
      >
        Editar Bimlink
      </Tooltip>
      
      <IconButton
        className="edit-btn"
        onClick={handleOnClick}
      >
        <EditIcon fontSize="large" />
      </IconButton>
    </>
  )
}

export default EditBimLinkButton
